import React, { useState, useLayoutEffect, useCallback } from 'react'

// Universali onboarding užuomina. Paryškina taikinį (targetRef arba aiškus rect)
// „skyle" tamsoje ir parodo burbuliuką. Be taikinio — centruota kortelė.
//
// props: targetRef? / rect? (aiškus), rodykle? ('up'), ikona?, antraste, tekstas,
//        zingsnis? ("2 / 5"), paskutinis?, onKitas, onPraleisti?
function CoachMark({ targetRef, rect: rectProp, rodykle, svarbus, ikona, antraste, tekstas, zingsnis, paskutinis, onKitas, onPraleisti }) {
  const [rect, setRect] = useState(rectProp || null)

  const matuoti = useCallback(() => {
    if (rectProp) { setRect(rectProp); return }
    if (targetRef && targetRef.current) {
      const r = targetRef.current.getBoundingClientRect()
      setRect({ top: r.top, left: r.left, width: r.width, height: r.height, bottom: r.bottom })
    } else {
      setRect(null)
    }
  }, [targetRef, rectProp])

  useLayoutEffect(() => {
    matuoti()
    const t = setTimeout(matuoti, 420) // po lentelės/animacijų
    window.addEventListener('resize', matuoti)
    window.addEventListener('scroll', matuoti, true)
    return () => { clearTimeout(t); window.removeEventListener('resize', matuoti); window.removeEventListener('scroll', matuoti, true) }
  }, [matuoti])

  const vh = typeof window !== 'undefined' ? window.innerHeight : 800
  const vw = typeof window !== 'undefined' ? window.innerWidth : 390
  const pad = 6
  const burbW = svarbus ? Math.min(346, vw - 24) : Math.min(300, vw - 32)

  let burbStyle
  if (rect) {
    const centras = rect.left + rect.width / 2
    let bLeft = Math.max(16, Math.min(centras - burbW / 2, vw - 16 - burbW))
    if (rect.height > vh * 0.5) {
      burbStyle = { left: bLeft, width: burbW, bottom: 84 } // platus taikinys — burbulas apačioje
    } else {
      const zemiau = rect.bottom < vh * 0.58
      burbStyle = zemiau
        ? { top: rect.bottom + pad + (rodykle === 'up' ? 20 : 12), left: bLeft, width: burbW }
        : { top: rect.top - pad - 12, left: bLeft, width: burbW, transform: 'translateY(-100%)' }
    }
  }

  const Kortele = (
    <div style={{ background: '#E5A840', color: '#141F1A', borderRadius: 14, padding: '14px 16px', boxShadow: '0 10px 30px rgba(0,0,0,0.4)' }}>
      {zingsnis && <div style={{ fontSize: 11, fontWeight: 500, opacity: 0.75, marginBottom: 4, fontFamily: 'Syne, system-ui, sans-serif' }}>{zingsnis}</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        {ikona}
        <div style={{ fontFamily: "'Lora', Georgia, serif", fontSize: 17, fontWeight: 600 }}>{antraste}</div>
      </div>
      <div style={{ fontSize: 13, lineHeight: 1.5, fontFamily: 'Syne, system-ui, sans-serif' }}>{tekstas}</div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 12 }}>
        {onPraleisti
          ? <button onClick={onPraleisti} style={{ background: 'transparent', border: 'none', color: 'rgba(20,31,26,0.7)', fontSize: 12, cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif', padding: 0 }}>Praleisti</button>
          : <span />}
        <button onClick={onKitas} style={{ background: '#141F1A', color: '#E5A840', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif' }}>
          {paskutinis ? 'Supratau' : 'Kitas ›'}
        </button>
      </div>
    </div>
  )

  // Svarbi (pagrindinė) žinutė — didesnė kortelė ant tamsaus fono su žaliu akcentu
  const SvarbiKortele = (
    <div style={{ background: '#1E2E27', border: '1px solid rgba(127,179,105,0.5)', borderRadius: 16, padding: '20px 22px', boxShadow: '0 14px 40px rgba(0,0,0,0.55)' }}>
      {zingsnis && <div style={{ fontSize: 11, fontWeight: 500, color: '#7A8A7E', marginBottom: 10, fontFamily: 'Syne, system-ui, sans-serif' }}>{zingsnis}</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <div style={{ width: 44, height: 44, borderRadius: '50%', flexShrink: 0, background: 'rgba(127,179,105,0.16)', border: '1px solid rgba(127,179,105,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7FB369" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="19" r="3" /><circle cx="18" cy="5" r="3" /><path d="M9 19h6a3 3 0 0 0 3-3V8" /></svg>
        </div>
        <div style={{ fontFamily: "'Lora', Georgia, serif", fontSize: 21, fontWeight: 600, color: '#F0E8D5' }}>{antraste}</div>
      </div>
      <div style={{ color: '#B0B8A8', fontSize: 13.5, lineHeight: 1.6, fontFamily: 'Syne, system-ui, sans-serif' }}>{tekstas}</div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 18 }}>
        {onPraleisti
          ? <button onClick={onPraleisti} style={{ background: 'transparent', border: 'none', color: '#7A8A7E', fontSize: 12, cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif', padding: 0 }}>Praleisti</button>
          : <span />}
        <button onClick={onKitas} style={{ background: '#7FB369', color: '#141F1A', border: 'none', borderRadius: 9, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif' }}>
          {paskutinis ? 'Supratau' : 'Kitas ›'}
        </button>
      </div>
    </div>
  )

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2000 }}>
      <style>{`@keyframes cmSuoklis { 0%,100%{transform:translate(-50%,0)} 50%{transform:translate(-50%,-8px)} }`}</style>

      {/* Klikų gaudyklė (užtamsinimą kuria „skylės" box-shadow arba centro fonas) */}
      <div style={{ position: 'absolute', inset: 0, background: rect ? 'transparent' : 'rgba(12,19,16,0.72)' }} />

      {rect && rodykle !== 'up' && (
        <div style={{
          position: 'fixed',
          top: rect.top - pad, left: rect.left - pad,
          width: rect.width + pad * 2, height: rect.height + pad * 2,
          border: '2px solid #E5A840', borderRadius: 12,
          boxShadow: '0 0 0 9999px rgba(12,19,16,0.72)',
          pointerEvents: 'none', transition: 'all 0.2s ease',
        }} />
      )}

      {/* Rodyklė aukštyn (vietoj rėmelio) — „patrauk viršun" */}
      {rect && rodykle === 'up' && (
        <>
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(12,19,16,0.72)', pointerEvents: 'none' }} />
          <div style={{ position: 'fixed', top: rect.top - 40, left: rect.left + rect.width / 2, animation: 'cmSuoklis 1.1s ease-in-out infinite', color: '#E5A840', pointerEvents: 'none' }}>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 19V5M5 12l7-7 7 7" /></svg>
          </div>
        </>
      )}

      {rect ? (
        <div style={{ position: 'fixed', ...burbStyle }}>{Kortele}</div>
      ) : (
        <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ width: burbW }}>{svarbus ? SvarbiKortele : Kortele}</div>
        </div>
      )}
    </div>
  )
}

export default CoachMark
